module.exports = {
	"sellers": {
		"trade_name": "Nome da empresa",
		"email": "E-mail",
		"phone": "Telefone",
		"username": "Endereço de acesso",
		"attributes": {
			"email": "E-mail",
			"cpf": "CPF",
			"cnpj": "CNPJ",
			"trade_name": "Razão Social",
			"password": "Senha",
			"username": "Usuário",
			"contact": {
				"number": "Telefone",
				"area_code": "Código de Área (DDD)"
			},
			"address": {
				"postal_code": "CEP",
				"street": "Rua",
				"number": "Número",
				"neighborhood": "Bairro",
				"complement": "Complemento",
				"city": "Cidade",
				"state": "Estado"
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./~/yaml-loader!./src/lang/sellers/pt-BR.yml
// module id = 590
// module chunks = 1